export default "__VITE_ASSET__3abb89c1__"